import {
  HistoryMessageItem,
  IMFile,
  IMForwarding,
  MessageIncomingEvent,
  MessageOutgoingEvent,
  MessageStatusType,
  PinnedMessage,
} from '@wui/im'

import { VOICE_MESSAGE_SUB_TYPE } from '@/entities/voice-message'

import { isPinnedVoiceFile } from './get-pinned-preview'

const INCOMING_MESSAGE_TYPE = 9 as HistoryMessageItem['type']
const OUTGOING_MESSAGE_TYPE = 10 as HistoryMessageItem['type']

const resolvePinnedSubType = (files: IMFile[] | undefined) => {
  if (files?.length === 1 && files[0] && isPinnedVoiceFile(files[0])) {
    return VOICE_MESSAGE_SUB_TYPE
  }
  return undefined
}

export const resolvePinnedForwarding = (
  pin: PinnedMessage,
  roomPServed: string,
): IMForwarding | undefined => {
  const {
    forwardingEventId,
    forwardingText,
    forwardingChatPServed,
    forwardingAuthorName,
    forwardingFiles,
    forwardingTimestamp,
    files,
    sender,
  } = pin.extendedParams

  if (!forwardingEventId) {
    return undefined
  }

  const resolvedFiles = forwardingFiles?.length ? forwardingFiles : files

  return {
    forwardingEventId,
    forwardingChatPServed: forwardingChatPServed || roomPServed,
    forwardingText: forwardingText ?? pin.message ?? '',
    forwardingAuthorName: forwardingAuthorName || sender || pin.pServedUserExecuter,
    forwardingTimestamp: forwardingTimestamp ?? pin.timestamp,
    ...(resolvedFiles?.length ? { forwardingFiles: resolvedFiles } : {}),
  }
}

export const mapPinnedMessageToHistoryItem = (
  pin: PinnedMessage,
  roomPServed: string,
  currentUserImLogin?: string,
): HistoryMessageItem<MessageIncomingEvent | MessageOutgoingEvent> => {
  const sender = pin.extendedParams?.sender ?? pin.pServedUserExecuter
  const isOutgoing = Boolean(currentUserImLogin && sender === currentUserImLogin)
  const files = pin.extendedParams?.files
  const forwarding = resolvePinnedForwarding(pin, roomPServed)
  const subType = resolvePinnedSubType(forwarding?.forwardingFiles ?? files)

  const messageText = forwarding
    ? ''
    : (pin.message ?? '')

  if (isOutgoing) {
    const item: MessageOutgoingEvent = {
      type: 'OutgoingMessageEvent',
      executor: sender,
      messageText,
      pServed: roomPServed,
      ...(files && !forwarding ? { files } : {}),
      ...(forwarding ? { forwarding } : {}),
      ...(subType ? { subType } : {}),
    }

    return {
      eventId: pin.eventId,
      rank: pin.rank,
      timestamp: pin.timestamp,
      status: MessageStatusType.ACCEPTED,
      type: OUTGOING_MESSAGE_TYPE,
      item,
    }
  }

  const item: MessageIncomingEvent = {
    type: 'IncomingMessageEvent',
    executor: sender,
    messageText,
    pServed: roomPServed,
    eventId: pin.eventId,
    rank: pin.rank,
    timestamp: pin.timestamp,
    ...(files && !forwarding ? { files } : {}),
    ...(forwarding ? { forwarding } : {}),
    ...(subType ? { subType } : {}),
  }

  return {
    eventId: pin.eventId,
    rank: pin.rank,
    timestamp: pin.timestamp,
    status: MessageStatusType.ACCEPTED,
    type: INCOMING_MESSAGE_TYPE,
    item,
  }
}
